// extracted by mini-css-extract-plugin
module.exports = {"noCompanies":"noCompanies-1JveTtEHW4P6vsafCGtd40","message":"message-1GrVuCxANuDpN0cPmJAKDH"};